module.exports = __webpack_public_path__ + "static/logo-dfaa2f54828f9f7af8362641016604f1.png";